import SvgIcon from "@mui/material/SvgIcon";

export default function SvgTurnRightDisabled() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12.603"
        height="15.943"
        viewBox="0 0 12.603 15.943"
      >
        <path
          id="Path_648"
          data-name="Path 648"
          d="M86.836,65.361H83.2a3.6,3.6,0,0,0-3.6,3.6v6.724a1.28,1.28,0,1,0,2.559,0V68.961A1.042,1.042,0,0,1,83.2,67.92h3.634l-1.061,1.061a1.28,1.28,0,0,0,1.81,1.81l3.245-3.245a1.28,1.28,0,0,0,0-1.81L87.6,62.5a1.28,1.28,0,1,0-1.81,1.81Z"
          transform="translate(-79.102 -61.521)"
          fill="#5C5470"
          stroke="#352F44"
          strokeWidth="1"
        />
      </svg>
    </SvgIcon>
  );
}
